module.exports = __webpack_public_path__ + "static/media/followup-online-search.23076521.svg";